import React, { useEffect, useState } from 'react';
import BackButton from "../../../Components/BackButton";
import TitlePages from "../../../Components/TitlePages";
import axios from 'axios';
import {
  Container,
  SizeContainer,
  Title,
  MainContainer,
  ButtonsDiv,
  ButtonCompanies,
  ButtonDeleteCompanies,
  ButtonAddCompanies,
  InputAddIndustry,
  ContainerStock,
} from "./style";
import Loading from '../../../Components/Loading';

const SetupBaseMarketplace = () => {
  const [marketPlaces, setmarketPlaces] = useState(null)
  const [loading, setLoading] = useState(false)
  const [showInputToAddMarketPlace, setShowInputToAddMarketPlace] = useState(false)
  const [nameMarketPlace, setNameMarketPlace] = useState('')

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  async function handleAddMarketPlace() {
    if (nameMarketPlace.trim().length === 0) return
    try {
      setLoading(true)
      await api.post(`/api/supermercado/cadastrarSupermercadoBase`, {
        nome: nameMarketPlace
      })
      setShowInputToAddMarketPlace(false)
      fetchmarketPlaces()

    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }

  }

  async function fetchmarketPlaces() {
    try {
      api.get(`/api/supermercado/listarBase`)
        .then(response => setmarketPlaces(response.data))
    } catch (error) {
      console.log(error)
    }
  }


  useEffect(() => {
    fetchmarketPlaces()
  }, [])

  return (
    <Container>
      <SizeContainer>
        <TitlePages text="Setup Base Indústrias" />
        <BackButton path="/menuMarketplace" />

        <Title>
          Número de Supermercados na base <span>{marketPlaces?.length ?? 0}</span>
        </Title>
        <MainContainer>
          <ButtonsDiv >
            <ButtonAddCompanies disabled={loading} onClick={() => setShowInputToAddMarketPlace(!showInputToAddMarketPlace)} >+</ButtonAddCompanies>
          </ButtonsDiv>
          {
            showInputToAddMarketPlace ? (
              <>
                <ContainerStock>
                  <ButtonsDiv>
                    {loading ? (
                      <Loading style={{
                        height: 100
                      }} />
                    ) : (
                      <>
                        <ButtonCompanies style={{ background: "#fff" }}><InputAddIndustry name={nameMarketPlace} onChange={e => setNameMarketPlace(e.target.value)} placeholder="Nome do supermercado" type="text" /></ButtonCompanies>
                        <ButtonDeleteCompanies onClick={() => handleAddMarketPlace()} >&#9989;</ButtonDeleteCompanies>
                      </>
                    )

                    }
                  </ButtonsDiv>
                </ContainerStock>

              </>
            ) : null

          }

          <span>Supermercados na base</span>
          {marketPlaces?.length === 0 ? (
            <div>
              <span style={{ fontSize: 16 }}>Nenhum supermercado cadastrado na base.</span>
            </div>
          ) : (
            marketPlaces?.map((marketPlace, k) => {
              return (
                <div key={k}>
                  <ButtonsDiv  >
                    <ButtonCompanies onClick={() => { }} >{marketPlace.nome}</ButtonCompanies>
                  </ButtonsDiv>
                </div>
              )
            })
          )
          }
        </MainContainer>
      </SizeContainer >
    </Container >
  );
};
export default SetupBaseMarketplace;
